<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 14:38:03
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-07-15 14:04:36
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/components/FoodAddOrEdit/index.vue
-->
<template>
    <div class="foodadd-edit">
         <el-scrollbar ref="scrollbar" style="height: 100%" wrap-style="overflow-x:hidden;">
            <section class="section-food">
                <div class="header">
                    <p></p>
                    <h1>{{isFoodType ? '新增' : '修改'}}食物</h1>
                </div>
                <el-form
                size="small"
                label-width="100px"
                label-position="left"
                :rules="addFoodrules"
                :model="fromParamData"
                ref="addRuleForm"
                >
                    <el-form-item label="食物名称:" prop="name">
                        <el-input v-model="fromParamData.name"  placeholder="请输入食物名称"></el-input>
                    </el-form-item>

                    <el-form-item label="食物简称:" prop="abbreviation">
                        <el-input v-model="fromParamData.abbreviation"  placeholder="请输入食物简称"></el-input>
                    </el-form-item>

                    <div v-if="showViewFlag">
                        <el-form-item label="食物大类:" prop="foodBigId">
                            <el-select 
                            v-model="fromParamData.foodBigId" 
                            @change="selectFoodMaxClassChange"
                            ref="selectFoodBigRef"
                            placeholder="请选择食物大类">
                                <el-option 
                                v-for="item in foodTreeData"
                                :key="item.index"
                                :label="item.categoryName" 
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="食物小类:" prop="foodSmallId">
                            <el-select 
                            ref="selectFoodSmallRef"
                            v-model="fromParamData.foodSmallId" 
                            placeholder="请选择食物小类">
                                <el-option 
                                v-for="item in foodSmallList"
                                :key="item.index"
                                :label="item.categoryName" 
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="是否启用:" prop="status">
                            <el-radio-group v-model="fromParamData.status">
                                <el-radio :label='0'
                                
                                >是</el-radio>
                                <el-radio :label='1'>否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </el-form>
            </section>

            <section class="section-maintain">
                <div class="header">
                    <p></p>
                    <h1>营养素维护</h1>
                </div>

                <el-form
                size="small"
                label-position="left"
                inline
                label-width="128px"
                :rules="addFoodrules"
                :model="fromParamData"
                ref="maintainRuleForm"
                >
                <!-- <el-form-item 
                    prop='ediblePart'
                    label="可食部 %："
                    >
                        <el-input
                        placeholder="请填写123"
                        v-model="fromParamData.ediblePart"
                        ></el-input>
                    </el-form-item> -->

                    <el-form-item 
                    :label="item.label"
                    v-for="(item,index) in formList"
                    :key="index"
                    >
                    <!-- v-show="item.name != 'ediblePart' " -->
                        <el-input
                        @input="inputChage(item,$event)"
                        placeholder="请填写"
                        v-model="item.value"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="submit-btn">
                        <el-button @click="updateFoodType">取消</el-button>
                        <el-button @click="replacementHandel">重置</el-button>
                        <el-button type="primary" @click="submitHandel">保存</el-button>
                    </el-form-item>
                </el-form>
            </section>

        </el-scrollbar>
    </div>
</template>
<script>
import fromList from '../../common/form.config';
import {apiPostAddFood} from '../../api';
import eventBus from '@/utils/eventBus'

export default {
    name:'FoodAddOrEdit',
    mixins:[fromList],
    props:{
        //食物分类
        foodTreeData:{
            type:Array,
            default:()=>[]
        },
        //是新增还是修改
        isFoodType:{
            type:Boolean,
            default:true
        },
        //数据回显
        showParamsData:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
            showViewFlag:true,//解决重置或者清空后验证规则还存在的bug
            foodBigList:[],//食物大类列表
            foodSmallList:[],//食物小类列表
            //需要提交的参数
            fromParamData:{
                id:'',
                abbreviation:'',//食品简称
                name:'',//食品名称	
                foodBigId:'',//食品大类id
                foodSmallId:'',//食品小类id
                status:0,//	0启用 1停用

                ediblePart:'100',//可食部 %
                moisture:'',//水分 g：
                energyKcal:'',//能量 kcal：
                energyKj :'',//能量KJ：
                protein:'',//蛋白质 g：
                fat:'',//脂肪 g：
                carbohydrate:'',//碳水化合物 g：
                cholesterol:'',//胆固醇 g：
                insolubleDietaryFiber:'',//不溶性膳食纤维 g：
                solubleDietaryFiber:'',//可溶性膳食纤维 g：
                ash:'',//灰分 g：
                totalVitaminA:'',//总维生素A μgRAE：
                carrot:'',//胡萝卜素 μg：
                retinol:'',//视黄醇 μg：
                totalVitaminE:'',//总维生素E mg：
                vitaminEa:'',//α-维生素E mg：
                vitaminEb:'',//β+γ-维生素E mg：
                vitaminEc:'',//δ-维生素E mg：
                vitaminD:'',//维生素D mg：
                vitaminK:'',//维生素K mg：
                vitaminC:'',//维生素C mg：
                niacin:'',//烟酸 mg：
                vitaminBOne:'',//维生素B1 mg：
                vitaminBTwo:'',//维生素B2 mg：
                vitaminBSix:'',//维生素B6 mg：
                vitaminBTwelve:'',//维生素B12 mg：
                folicAcid:'',//叶酸 mg：
                pantothenicAcid:'',//泛酸 mg：
                calcium:'',//钙 mg：
                phosphorus:'',//磷 mg：
                potassium:'',//钾 mg：
                sodium:'',//钠 mg：
                magnesium:'',//镁 mg：
                zinc:'',//锌 mg：
                iron:'',//铁 mg：
                copper:'',//铜 mg：
                selenium:'',//硒 mg：
                manganese:'',//锰 mg：
                iodine:'',//碘 mg：
                chlorine:'',//氯 mg：
                sodiumChloride:'',//氯化钠 mg：
                potassiumChloride:'',//氯化钾 mg：
                asparticAcid:'',//天冬氨酸 mg
                threonine:'',//苏氨酸
                serine:'',//丝氨酸
                glutamicAcid:'',//谷氨酸
                proline:'',//脯氨酸
                glycine:'',//甘氨酸
                alanine:'',//丙氨酸
                cysteine:'',//半胱氨酸
                valine:'',//缬氨酸
                methionine:'',//蛋氨酸
                isoleucine:'',//异亮氨酸
                leucine:'',//亮氨酸
                tyrosine:'',//酪氨酸
                phe:'',//苯丙氨酸
                lysine:'',//赖氨酸
                histidine:'',//组氨酸
                arginine:'',//精氨酸
                tryptophan:'',//色氨酸
                biotin:'',//生物素
                choline:'',//胆碱
                purine :'',//嘌呤
                glycemicIndex:'',//血糖指数：
                unknownFat:'',//未知脂肪
                fattyAcid:'',//脂肪酸
                oneFattyAcid:'',//单不饱和脂肪酸比
                moreFattyAcid:'',//多不饱和脂肪酸比
                saturatedFattyAcid:'',//饱和脂肪酸比
                totalPhytosterols:'',//植物甾醇总量
                sitosterol:'',//β谷甾醇
                campesterol:'',//菜油甾醇
                glutanols:'',//β谷甾烷醇
                stigmasterol:'',//豆甾醇
                canolaSteranols:'',//菜油甾烷醇
            },
        }
    },
    watch:{
        showParamsData:{
            handler(newVal,oldVal){
                this.echoHandel(newVal)
            },
            deep:true
        }
    },
    mounted(){
        this.handleScroll()
    },
    methods:{
          /**
         * @description: 新增食物和修改食物
         * @param {*}
         * @return {*}
         */        
        submitSuccessHandel(optios){
            this.showViewFlag = false;
            apiPostAddFood(optios).then(res=>{
                this.showViewFlag = true;
                if(res.code == 0 ){
                    if(this.isFoodType){
                        eventBus.$emit('defaultExpandedKeys', this.fromParamData.foodBigId);
                    }
                    this.formList = this.formList.map(item=>{
                        item.value ='';
                        return item
                    });
                    this.fromParamData = this.$options.data().fromParamData;
                    this.formList[0].value = '100'
                    this.$emit('submitSuccess');
                    this.scrollHandel();
                }
            })
        },
        /**
         * @description: 重置功能
         * @param {*}
         * @return {*}
         */        
        replacementHandel(){
            const id = this.fromParamData.id;
            this.fromParamData = this.$options.data().fromParamData;
            this.fromParamData.id = id;
            this.formList = this.formList.map(item=>{
                item.value ='';
                return item
            })
            this.scrollHandel()
        },

        /**
         * @description: 数据回显
         * @param {*}
         * @return {*}
         */        
        echoHandel(value){
            Object.keys(this.fromParamData).forEach(item=>{
                this.fromParamData[item] = value[item]
            });
            if(this.fromParamData.foodBigId){
                this.foodSmallList = this.foodTreeData.filter(item=>item.id == value.foodBigId)[0].children;
            }
            this.formList.forEach(item=>{
                item.value = value[item.name] || ''
            })
        },

        /**
         * @description: 更新父组件传递过来的参数
         * @param {*}
         * @return {*}
         */        
        updateFoodType(){   
            this.showViewFlag = false;

            if(!this.isFoodType) this.$emit( 'update:isFoodType', !this.isFoodType );
             this.formList = this.formList.map(item=>{
                item.value ='';
                return item
            });
            this.fromParamData = this.$options.data().fromParamData;
            setTimeout(()=>{
                this.showViewFlag = true;
            },10)
            this.scrollHandel();
           
        },
        /**
         * @description: 初始化滚动条
         * @param {*}
         * @return {*}
         */        
        scrollHandel(){
            this.$refs.scrollbar.wrap.scrollTop = 0  //想滚到哪个高度，就写多少
        },

        /**
         * @description: 监听滚动事件，当滚动距离大于 关闭select选择框
         * @param {*}
         * @return {*}
         */        
        handleScroll(){
            let scrollbarEl = this.$refs.scrollbar.wrap;
            scrollbarEl.onscroll = () => {
                if(scrollbarEl.scrollTop > 178)  this.$refs.selectFoodBigRef.blur()
                if(scrollbarEl.scrollTop > 230) this.$refs.selectFoodSmallRef.blur()
            }
        },
       
        /**
         * @description: 
         * @param {*}
         * @return {*}
         */        
        inputChage(item,e){
            // var reg = (/\d+\.\d+/g)
            // [1-9]\d*\.?\d*)|(0\.\d*[1-9]
            var reg = /[1-9][0-9]*/g;
            item.value = item.value.replace(/[^\d^\.]+/g,'')
            // item.value = item.value.match(reg) && item.value.match(reg).join('')
            // if(item.value.match(/\d+\.\d+/g)) item.value = item.value.match(/\d+\.\d+/g)[0]
            // if(reg.exec(item.value)){
            //     // 包含        
            // }
        },
        /**
         * @description: 保存
         * @param {*}
         * @return {*}
         */        
        submitHandel(){
            let fromFlag = true
            this.$refs['addRuleForm'].validate((valid) => {
                if (valid) {
                }else{
                    fromFlag = false
                }
            });
            this.$refs['maintainRuleForm'].validate((valid) => {
                if (valid) {
                }else{
                    fromFlag = false
                }
            });
            if(fromFlag){
                Object.keys(this.fromParamData).forEach(item=>{
                    if(this.formList.filter(sub=>sub.name == item)[0]){
                        this.fromParamData[item] = this.formList.filter(sub=>sub.name == item)[0].value;
                    }
                })
                this.submitSuccessHandel(this.fromParamData);
            }
        },
        /**
         * @description: 选择大类得到小类下面的children为小类
         * @param {*}
         * @return {*}
         */        
        selectFoodMaxClassChange(e){
            this.fromParamData.foodSmallId = '';
            this.foodSmallList = this.foodTreeData.filter(item=>item.id == e)[0].children;
           
        },
    }
}
</script>

<style scoped lang="less">
.foodadd-edit{
    padding: 16px;
        height: calc( 100vh - 254px );

    .header{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        p{
            width: 4px;
            height: 15px;
            background: #1A7BFC;
            margin-right: 12px;
        }
        h1{
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
        }
    }
    .section-food{
        
        .el-input , .el-select{
            width: 360px;
        }
        /deep/.el-form-item__label{
            text-align: center;
            font-weight: 400;
            color: #333333;
            font-size: 12px;
        }
    }
    .section-maintain{
        /deep/.el-form-item__label{
            text-align: center;
            font-weight: 400;
            color: #333333;
            font-size: 12px;
        }
        .el-form-item{
            width: 50%;
            margin-right: 0;
            .el-input{
                width: 135px;
            }
        }
        .submit-btn{
            width: 100%;
            display: flex;
            // align-items: center;
            justify-content: center;
            /deep/.el-form-item__label{
                text-align: center;
                font-weight: 400;
                color: #333333;
                font-size: 12px;
            }
            & /deep/ .el-button--default{
                width: 110px;
                height: 32px;
            }
            &/deep/ .el-button--primary{
                background-color:#1A7BFC;
                width: 110px;
                height: 32px;
            }
            &/deep/ .el-button:focus, .el-button:hover {
                border-color: #1A7BFC;
            }
        }
    }
}

</style>